import { BaseApiClient } from "@eusoft/webapp-framework";
import { ISong } from "./Entities";

class ApiClient extends BaseApiClient {

    parseMidiAsync(url: string, channel?: number) {
        return this.requestJsonAsync<ISong>("midi/parse" + (channel !== undefined ? "/" + channel : ""), "GET", undefined, {
            url
        });
    }
}


export const apiClient = new ApiClient();